import { type ChangeEvent, useState } from "react";

import { InputControl } from "@vega-core/components/Form/Controls/Input/InputControl";
import { ActionaryModal } from "@vega-core/components/Modals/ActionaryModal/ActionaryModal";
import { type UseBooleanReturn } from "@vega-core/hooks/useBoolean";
import { m } from "@vega-core/paraglide/messages";
import { useSavedFilters } from "@vega-modules/hooks/useSavedFilters";

import { type FilterState, type TableFilterId } from "../../types";

export const SaveFiltersModal = ({
  saveModal,
  filterState,
  id,
  applyContextInPersistenceKeys = true,
}: {
  saveModal: UseBooleanReturn;
  filterState: FilterState;
  id: TableFilterId;
  applyContextInPersistenceKeys?: boolean;
}) => {
  const [name, setName] = useState("");
  const { saveFilter, isSaving } = useSavedFilters(
    id,
    applyContextInPersistenceKeys,
  );

  const isDisabled = isSaving || !name;

  const handleSave = async () => {
    try {
      await saveFilter(name, filterState);
      saveModal.setIsOpen(false);
      setName("");
    } catch (error) {
      console.error("Failed to save filter:", error);
    }
  };

  return (
    <ActionaryModal
      ModalButtonsGroupProps={{
        disabled: isDisabled,
        mainAction: () => {
          handleSave();
        },
        mainActionText: m.common_save(),
        secondaryAction: () => {
          saveModal.setIsOpen(false);
        },
      }}
      defaultWidth
      open={saveModal.isOpen}
      setOpen={saveModal.setIsOpen}
      title={m.common_new_filter()}
    >
      <InputControl
        label={m.common_name()}
        name="name"
        onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
        type="text"
        value={name}
        withBorder
      />
    </ActionaryModal>
  );
};
